import '../styles/components/product-card.css'
import { formatPrice, imagePlaceholder } from '../utils/helpers.js'
import { store } from '../store.js'
import { showToast } from '../utils/helpers.js'

/**
 * Render a product card and return the DOM element
 * @param {Object} product
 * @returns {HTMLElement}
 */
export function createProductCard(product) {
  const card = document.createElement('div')
  card.className = 'product-card'
  card.dataset.id = product.id

  const image = product.images?.[0] || null
  const inStock = product.stock_qty > 0
  const purchasable = product.purchasable !== false

  card.innerHTML = `
    <div class="product-card-image">
      <img src="${image || imagePlaceholder(400, 300)}" alt="${escapeHtml(product.name)}" loading="lazy">
      ${!inStock ? '<div class="product-card-badge"><span class="badge">Out of Stock</span></div>' : ''}
    </div>
    <div class="product-card-body">
      <h3 class="product-card-name">${escapeHtml(product.name)}</h3>
      <p class="product-card-desc">${escapeHtml(product.description || '')}</p>
      <div class="product-card-footer">
        <span class="product-card-price">${formatPrice(product.price_cents)}</span>
        ${purchasable
          ? `<button class="btn btn-primary product-card-cta add-to-cart-btn" data-id="${product.id}" ${!inStock ? 'disabled' : ''}>${inStock ? 'Add to Cart' : 'Sold Out'}</button>`
          : `<a href="${sanitizeUrl(product.button_url)}" class="btn btn-secondary product-card-cta" ${product.button_url && !product.button_url.startsWith('#') ? 'target="_blank" rel="noopener noreferrer"' : ''}>${escapeHtml(product.button_text || 'Get in touch')}</a>`
        }
      </div>
    </div>
  `

  // Navigate to product detail on card click (not button/link)
  card.addEventListener('click', (e) => {
    if (e.target.closest('.add-to-cart-btn') || e.target.closest('a')) return
    window.location.hash = `#/product/${product.id}`
  })

  // Add to cart
  card.querySelector('.add-to-cart-btn')?.addEventListener('click', (e) => {
    e.stopPropagation()
    store.addToCart(product, 1)
    store.openCart()
    showToast(`${product.name} added to cart`, 'success')
  })

  return card
}

function sanitizeUrl(url) {
  if (!url) return '#/contact'
  const s = url.trim()
  if (s.startsWith('#') || s.startsWith('https://') || s.startsWith('http://')) return s
  return '#/contact'
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
